import axios from 'axios';
import {
  useCallback,
} from 'react';

import { baseUrl } from '../helpers/urls';
import { useCurrentUser } from '../contexts/CurrentUser.context';

const useUsers = () => {

  const {
    token,
  } = useCurrentUser();

  const getAll = useCallback(async (searchTerm) => {
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/users?searchTerm=${searchTerm}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {searchTerm: searchTerm}
    });
 
    return response.data;
  }, []);

  const getById = useCallback(async (id) => {
    const response = await axios.get(`${baseUrl}/users/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(response.data)
    return response.data;
  }, [token]);

  const create = useCallback(async () => {

    console.log(token);
    const response = await axios({
      method: 'POST',
      url: `${baseUrl}/users`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }, []);

  const update = useCallback(async (id, {firstname, lastname, email, street, number, postalcode, city, country}) => {
    const response = await axios({
      method: 'PUT',
      url: `${baseUrl}/users/${id}`,
      data: {firstname, lastname, email, street, number, postalcode, city, country},
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }, []);

  const login = useCallback(async () => {
    console.log(token)
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/users/login`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  }, []);

  const deleteUser = useCallback(async (id) => {
    const response = await axios({
      method: 'DELETE',
      url: `${baseUrl}/users/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  });

  return {
    getAll,
    getById,
    create,
    login,
    update,
    deleteUser
  };

};

export default useUsers;